import '../styles/explorevideos.css';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css'; // Correct way to import Swiper styles
import { useRef, useState } from 'react';
import React from 'react';
import '../styles/explorevideos.css';
import { useEffect } from 'react';
import AOS from 'aos';
import "aos/dist/aos.css";

const Explorevideos = ({ anim }) => {
    const swiperOneRef = useRef(null);
    const intervalRef = useRef(null);
    const isHoveredRef = useRef(false);
    const [, setOntimeIndex] = useState(0);
    const [oneTimeServices] = useState([
        {
            id: 1,
            title: "Maritime Industry Opportunities for Students!",
            description: "Discover how marine companies are teaming up with colleges to offer students incredible opportunities in the maritime industry! 🚢🔧 These collaborations provide hands-on experience, essential skills, and a direct path to careers in shipping, navigation, engineering, and more.",
            link: "https://www.youtube.com/watch?v=iEcC2qGyt2s"
        },
        {
            id: 2,
            title: "📚 SPONSORSHIP ENTRANCE EXAM | Everything You Need to Know! 🚢",
            description: "Are you ready to secure your spot in the maritime industry? 🌊 This video breaks down the Sponsorship Entrance Exam",
            link: "https://www.youtube.com/watch?v=dR8tTjHQWgI"
        },
        {
            id: 3,
            title: "Merchant Navy Sponsorship | Secure Your Future with Mariners Mentor!",
            description: "Looking for a rewarding career after 12th? 🚢 Dream of joining the Merchant Navy but unsure about sponsorship opportunities? Mariners Mentor is here to guide you!",
            link: "https://www.youtube.com/watch?v=A8SBih9Qd3s"
        },
        {
            id: 4,
            title: "Career guidance after GP Rating",
            description: "Just completed your GP Rating and wondering what's next? This video is your ultimate guide to exploring the best career opportunities available to you in the maritime industry. Whether you're aiming for higher studies, seeking specialized certifications, or looking to start your career on board, we've got you covered.",
            link: "https://www.youtube.com/watch?v=kWt-iRLqHqU"
        },
        {
            id: 5,
            title: "Financial Advice for Seafarers: Save Money for a Secure Future",
            description: "As a seafarer, planning for your financial future is essential. In this video, we offer valuable advice on how to save money effectively while working at sea. Learn about building an emergency fund, smart investing, reducing unnecessary expenses, and making the most of your hard-earned income. These tips are designed to help you secure your financial future and enjoy long-term financial stability. Start saving today for a brighter tomorrow!",
            link: "https://www.youtube.com/watch?v=-clwu5Hd_-c"
        }
    ]);

    const swiperBreakpoints = {
        320: { slidesPerView: 1 },
        768: { slidesPerView: 2 },
        1024: { slidesPerView: 3 },
    };

    const handleSlideChangeOneTime = (swiper) => {
        setOntimeIndex(swiper.realIndex);
    };

    const getAosData = (animation, delay) => {
        return anim === "true" ? null : { "data-aos": animation, "data-aos-delay": delay };
    };

    const startAutoSlide = () => {
        if (!intervalRef.current) {
            intervalRef.current = setInterval(() => {
                if (swiperOneRef.current && !isHoveredRef.current) {
                    swiperOneRef.current.swiper.slideNext();
                }
            }, 3000);
        }
    };

    const stopAutoSlide = () => {
        if (intervalRef.current) {
            clearInterval(intervalRef.current);
            intervalRef.current = null;
        }
    };

    useEffect(() => {
        startAutoSlide();
        
        if (anim !== "true") {
            AOS.init({
                duration: 1000, // Optional: you can customize the animation duration or other settings
                once: true, // Optional: ensures animations only trigger once
                startEvent: 'DOMContentLoaded', // Optional: triggers AOS on specific event
            });
        }

        return () => stopAutoSlide(); // Cleanup interval on component unmount
    }, [anim]);

    return (
        <div className="container-width">
            <div className="d-flex justify-content-between">
                <h1 className="section-title fs-2" style={{ color: "#2CB665" }} {...getAosData("fade-up", "100")}>
                    Explore Our Videos
                </h1>
                <a {...getAosData("fade-up", "100")} href="https://www.youtube.com/@marinersmentor1262" target='blank' style={{ fontSize: "15px", backgroundColor: "#2CB665", color: "white", borderRadius: "10px", padding: "8px 12px", border: "none", height: "fit-content", whiteSpace: "nowrap"}}>
                    View All
                </a>
            </div>
            <h2 {...getAosData("fade-up", "100")} className="service-section-title pt-4">
                We create your perfect Career Guidance through our Videos
            </h2>
            <div className="d-flex justify-content-between">
                <p {...getAosData("fade-up", "100")} className="services-header-txt text-start">
                    Explore our Trending Videos.
                </p>
            </div>

            <div 
                className="d-flex justify-content-between mt-3"
                onMouseEnter={() => {
                    isHoveredRef.current = true;
                }}
                onMouseLeave={() => {
                    isHoveredRef.current = false;
                }}
            >
                <Swiper
                    spaceBetween={20}
                    breakpoints={swiperBreakpoints}
                    onSlideChange={handleSlideChangeOneTime}
                    ref={swiperOneRef}
                    className="pb-3"
                    {...getAosData("fade-up", "200")}
                    loop={true}
                    // Remove built-in autoplay to use custom implementation
                >
                    {oneTimeServices.map((service) => (
                        <SwiperSlide style={{position:"relative",height:'100%',padding:'10px'}} key={service.id}>
                            <div style={{height:"100%",backgroundColor:"white", borderRadius:"12px",boxShadow:"2px 3px 3px 3px lightgrey", padding:'15px'}} className="col">
                                <div className="explore-card">
                                    <div className="card-header">
                                        <iframe
                                            width="100%"
                                            height="200"
                                            style={{ borderRadius: "12px" }}
                                            src={service.link.replace("watch?v=", "embed/")}
                                            title="YouTube video player"
                                            frameBorder="0"
                                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                            allowFullScreen
                                        ></iframe>
                                    </div>
                                    <div className="explore-body">
                                        <h5 className="card-title">{service.title}</h5>
                                        <p className="card-text">
                                            {service.description.length > 200 ? service.description.substring(0,50)+"..." : service.description+"..."} 
                                            <a href={service.link} target="blank" style={{color:'#2CB665'}}>see more</a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </SwiperSlide>
                    ))}
                </Swiper>
            </div>
        </div>
    );
};

export default Explorevideos;